/** Vietnamese number reading (SPEC §4.3): 21 "hai mươi mốt", 15 "mười lăm", 104 "một trăm linh tư". */
const DIGITS = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];

function readTens(n: number): string {
  // 0 < n < 100
  const tens = Math.floor(n / 10);
  const units = n % 10;
  if (tens === 0) return DIGITS[units] as string;
  if (tens === 1) {
    if (units === 0) return "mười";
    return `mười ${units === 5 ? "lăm" : DIGITS[units]}`;
  }
  const head = `${DIGITS[tens]} mươi`;
  if (units === 0) return head;
  if (units === 1) return `${head} mốt`;
  if (units === 5) return `${head} lăm`;
  return `${head} ${DIGITS[units]}`;
}

/** Read 0..999. `full` forces "không trăm" for inner groups (1 005 → "một nghìn không trăm linh năm"). */
function readHundreds(n: number, full: boolean): string {
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const parts: string[] = [];
  if (h > 0 || full) parts.push(`${DIGITS[h]} trăm`);
  if (rest > 0) {
    if (rest < 10 && (h > 0 || full)) parts.push(`linh ${rest === 4 ? "tư" : DIGITS[rest]}`);
    else parts.push(readTens(rest));
  }
  return parts.join(" ");
}

const SCALES = ["", "nghìn", "triệu", "tỉ"];

export function numberToWordsVi(n: number): string {
  if (!Number.isInteger(n)) throw new Error(`integer expected: ${n}`);
  if (n < 0) return `âm ${numberToWordsVi(-n)}`;
  if (n === 0) return "không";
  if (n >= 1e12) throw new Error("number too large");
  const groups: number[] = [];
  for (let v = n; v > 0; v = Math.floor(v / 1000)) groups.push(v % 1000);
  const words: string[] = [];
  for (let i = groups.length - 1; i >= 0; i--) {
    const g = groups[i] as number;
    if (g === 0) continue;
    const isLeading = i === groups.length - 1;
    words.push(readHundreds(g, !isLeading));
    if (SCALES[i]) words.push(SCALES[i] as string);
  }
  return words.join(" ");
}
